import styled from '@emotion/styled';
import { remCalc, palette } from '../../css';

const [squareSize, padding] = [30, 10];

const StyledList = styled('ul')(() => ({
    position: 'relative',
    margin: 0,
    display: 'flex',
    listStyle: 'none',
}));

const StyledItem = styled('li')(() => ({
    marginRight: remCalc(10),
    ':last-child': {
        marginRight: 0,
    },
}));

const StyledLink = styled('a')(() => ({
    transition: 'border-color ease-out .25s',
    display: 'block',
    boxShadow: `0 0 1px 1px ${palette('white', 'base')}`,
    borderRadius: '50%',
    width: remCalc(squareSize + padding * 2),
    height: remCalc(squareSize + padding * 2),
    padding,
    ':hover,:focus': {
        boxShadow: `0 0 1px 1px ${palette('white', 'alpha')}`,
    },
}));

const StyledImage = styled('img')(() => ({
    display: 'block',
    width: remCalc(squareSize),
    height: remCalc(squareSize),
}));

export { StyledImage, StyledItem, StyledLink, StyledList };
